var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visitor-page" },
    [
      !_vm.pickerMode
        ? _c(
            "div",
            { staticClass: "visitor-page-head" },
            [
              _vm._l(_vm.getEnabledMenuItems(), function (menu) {
                return _c(
                  "div",
                  { key: menu.key, staticClass: "visitor-page-head-item" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: {
                          ghost: _vm.currentPage !== menu.key,
                          primary: _vm.currentPage === menu.key,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changePage(menu.key)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(menu.title) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "visitor-page-head-item" },
                [
                  _c(
                    "a-popover",
                    {
                      attrs: {
                        placement: "bottomLeft",
                        trigger: "click",
                        overlayClassName: "channel-contacts-popover",
                        visible: _vm.channelContactsPopoverVisible,
                      },
                      on: {
                        visibleChange: function ($event) {
                          _vm.channelContactsPopoverVisible = $event
                        },
                      },
                    },
                    [
                      _c("template", { slot: "content" }, [
                        _c(
                          "div",
                          { staticClass: "channel-contacts-menu" },
                          _vm._l(_vm.channelContactsList, function (channel) {
                            return _c(
                              "div",
                              {
                                key: channel.key,
                                staticClass: "channel-contacts-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleChannelContactClick(
                                      channel
                                    )
                                  },
                                },
                              },
                              [
                                _c("PlatformIconViewer", {
                                  attrs: { platform: channel.platform },
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(channel.label))]),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("SupsisButton", { attrs: { ghost: "" } }, [
                        _vm._v(" Kanal kişileri "),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "visitor-page-content" },
        [
          _vm.currentPage === "visitors"
            ? _c(
                "div",
                { attrs: { id: "visitors" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "filter-sidebar",
                      class: [_vm.dropdown && "closed"],
                    },
                    [
                      _c("div", { staticClass: "filter-sidebar-content" }, [
                        _c("div", { staticClass: "filter-sidebar-group" }, [
                          _c(
                            "div",
                            { staticClass: "filter-sidebar-group-title" },
                            [_vm._v(_vm._s(_vm.$t("message.favorites")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filter-sidebar-group-content" },
                            [
                              _c(
                                "div",
                                { staticClass: "favorite-items" },
                                _vm._l(
                                  _vm.favFilters["page.contact-list"] || [],
                                  function (fav) {
                                    return _c(
                                      "div",
                                      {
                                        key: fav._id,
                                        staticClass: "favorite-item",
                                        class: {
                                          selected:
                                            _vm.selectedFavFilter &&
                                            _vm.selectedFavFilter._id ===
                                              fav._id,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "favorite-item-content",
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectFavFilter(fav)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "favorite-item-icon material-icons",
                                              },
                                              [_vm._v("star")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "favorite-item-text",
                                              },
                                              [_vm._v(_vm._s(fav.name))]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "SaveFilterModal",
                                          {
                                            attrs: { value: fav.name },
                                            on: {
                                              save: function ($event) {
                                                return _vm.saveFilter(
                                                  $event,
                                                  fav
                                                )
                                              },
                                              delete: function ($event) {
                                                return _vm.deleteFavFilter(
                                                  fav.key,
                                                  fav._id
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "content",
                                                  fn: function () {
                                                    return [_vm._v(" sa")]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "favorite-item-edit material-icons",
                                                },
                                                [_vm._v("edit")]
                                              ),
                                            ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-sidebar-group group-filters" },
                          [
                            _c(
                              "div",
                              { staticClass: "filter-sidebar-group-title" },
                              [_vm._v(_vm._s(_vm.$t("message.filters")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-sidebar-group-content" },
                              _vm._l(
                                _vm.filteredItems,
                                function (filter, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "item" },
                                    [
                                      _c("MiniFilterPreview", {
                                        attrs: {
                                          filters: _vm.filters,
                                          filter: filter,
                                        },
                                        on: {
                                          deleteFilter: function ($event) {
                                            return _vm.deleteFilter(index)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-sidebar-footer" }, [
                        _c(
                          "div",
                          { staticClass: "filter-sidebar-control" },
                          [
                            _c("Filters", {
                              attrs: { align: "top", items: _vm.filters },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "content",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "control-button" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("filter_alt")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chatbotv2.addFilter")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2291898476
                              ),
                              model: {
                                value: _vm.filteredItems,
                                callback: function ($$v) {
                                  _vm.filteredItems = $$v
                                },
                                expression: "filteredItems",
                              },
                            }),
                            _vm._v(" "),
                            _vm.filteredItems.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "control-button",
                                    on: { click: _vm.clearFilters },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("filter_alt_off")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.$t("chatbotv2.clearFilter"))
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "filter-sidebar-collapse",
                            on: {
                              click: function ($event) {
                                _vm.dropdown = !_vm.dropdown
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "information-text" }, [
                              _vm._v(_vm._s(_vm.$t("message.showHide"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                staticStyle: { cursor: "pointer" },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.dropdown
                                        ? "keyboard_double_arrow_right"
                                        : "keyboard_double_arrow_left"
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "visitors-content" }, [
                    _c(
                      "div",
                      [
                        _c("div", { staticClass: "tool-head" }, [
                          _c(
                            "div",
                            { staticClass: "left-side" },
                            [
                              _c(
                                "div",
                                { staticClass: "save-filter-bar" },
                                [
                                  _c("div", { staticClass: "filter-title" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.selectedFavFilter
                                            ? _vm.selectedFavFilter.name
                                            : _vm.$t("message.contactSearch")
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.selectedFavFilter
                                    ? _c(
                                        "SaveFilterModal",
                                        {
                                          attrs: {
                                            value: _vm.selectedFavFilter.name,
                                          },
                                          on: {
                                            save: function ($event) {
                                              return _vm.saveFilter(
                                                $event,
                                                _vm.selectedFavFilter
                                              )
                                            },
                                            delete: function ($event) {
                                              return _vm.deleteFavFilter(
                                                _vm.selectedFavFilter.key,
                                                _vm.selectedFavFilter._id
                                              )
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "content",
                                                fn: function () {
                                                  return [_vm._v(" sa")]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            566497030
                                          ),
                                        },
                                        [
                                          [
                                            _c("a-icon", {
                                              attrs: {
                                                type: "star",
                                                theme: "filled",
                                              },
                                            }),
                                          ],
                                        ],
                                        2
                                      )
                                    : _c(
                                        "SaveFilterModal",
                                        {
                                          on: { save: _vm.saveFilter },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "content",
                                                fn: function () {
                                                  return [_vm._v(" sa")]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            566497030
                                          ),
                                        },
                                        [
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "star" },
                                            }),
                                          ],
                                        ],
                                        2
                                      ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("a-input-search", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("message.typeSTToSearch"),
                                },
                                on: { change: _vm.onSearch },
                                model: {
                                  value: _vm.searchText,
                                  callback: function ($$v) {
                                    _vm.searchText = $$v
                                  },
                                  expression: "searchText",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right-side" },
                            [
                              _c(
                                "a-popover",
                                {
                                  attrs: {
                                    placement: "bottomRight",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "content" },
                                    _vm._l(_vm.allColumns, function (col) {
                                      return _c(
                                        "div",
                                        [
                                          _c(
                                            "a-checkbox",
                                            {
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onChangeCol(
                                                    col,
                                                    $event
                                                  )
                                                },
                                              },
                                              model: {
                                                value: col.enabled,
                                                callback: function ($$v) {
                                                  _vm.$set(col, "enabled", $$v)
                                                },
                                                expression: "col.enabled",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(col.title) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    { staticClass: "flex-center-center" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [_vm._v("app_registration")]
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "flex-center-center",
                                  on: { click: _vm.paddingReset },
                                },
                                [
                                  _c("div", { staticClass: "material-icons" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.paddingReseted
                                            ? "fullscreen"
                                            : "fullscreen_exit"
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-popover",
                                {
                                  attrs: {
                                    placement: "bottomRight",
                                    trigger: "click",
                                    overlayClassName: "download-popover",
                                  },
                                },
                                [
                                  _c("template", { slot: "content" }, [
                                    _c(
                                      "div",
                                      { staticClass: "download-options" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "export-csv-visitor-page",
                                            on: { click: _vm.exportToCSV },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("description")]
                                            ),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.downloadThePage"
                                                  )
                                                ) +
                                                " (CSV)\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "export-csv-visitor-page",
                                            class: {
                                              disabled: _vm.visitorDownloding,
                                            },
                                            on: { click: _vm.downloadAll },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("download")]
                                            ),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.downloadAllData"
                                                  )
                                                ) +
                                                " (XLSX)\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "export-csv-visitor-page",
                                            class: {
                                              disabled: _vm.visitorDownloding,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showSaveAsCustomerGroupModal(
                                                  "whatsapp"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("save")]
                                            ),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "visitor.saveAsCustomerGroup"
                                                  )
                                                ) +
                                                " (Whatsapp)\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "export-csv-visitor-page",
                                            class: {
                                              disabled: _vm.visitorDownloding,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showSaveAsCustomerGroupModal(
                                                  "email"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("save")]
                                            ),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "visitor.saveAsCustomerGroup"
                                                  )
                                                ) +
                                                " (Email)\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "export-csv-visitor-page",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showImportContactsModal(
                                                  "multiple"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("file_upload")]
                                            ),
                                            _vm._v(
                                              "\n                                            Kişileri İçe Aktar\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "export-csv-visitor-page",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showImportContactsModal(
                                                  "single"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("person_add")]
                                            ),
                                            _vm._v(
                                              "\n                                            Yeni Kişi Ekle\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      staticClass: "flex-center-center",
                                      staticStyle: { "margin-right": "3px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [_vm._v("more_horiz")]
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("supsis-table", {
                          class: {
                            "visitor-table": true,
                            expended: _vm.paddingReseted,
                          },
                          attrs: {
                            id: "supsis-contacts-list",
                            columns: _vm.tableColumns,
                            rows: _vm.visitors,
                            options: _vm.tableOptions,
                            "bottom-pagination": true,
                            "pagination-cursor": _vm.paginationCursor,
                          },
                          on: { "cursor-changed": _vm.paginationCursorChanged },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "emptyData",
                                fn: function () {
                                  return [
                                    _c("EmptyFilterResult", {
                                      attrs: {
                                        "clear-filters": _vm.clearFilters,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2820105168
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.saveAsCustomerGroupModalVisible
                    ? _c(
                        "Modal2",
                        {
                          attrs: {
                            title:
                              _vm.saveAsCustomerGroupModalVisible === "whatsapp"
                                ? _vm.$t("message.saveAsWhatsappCustomerGroup")
                                : _vm.$t("message.saveAsEmailCustomerGroup"),
                          },
                          on: {
                            cancel: _vm.closeCustomerGroupModal,
                            ok: _vm.saveCustomerGroup,
                          },
                        },
                        [
                          _vm.saveAsCustomerGroupModalVisible === "whatsapp"
                            ? _c("div", { staticClass: "custom-alert" }, [
                                _c(
                                  "div",
                                  { staticClass: "custom-alert-icon" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("info")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "custom-alert-content" },
                                  [
                                    _c("ul", [
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "visitor.filterResultMax5000"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "visitor.onlyContactsPhoneNumber"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: { placeholder: "Grup adını girin" },
                            model: {
                              value: _vm.customerGroupName,
                              callback: function ($$v) {
                                _vm.customerGroupName = $$v
                              },
                              expression: "customerGroupName",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm.currentPage === "banned-visitors"
            ? _c("BannedVisitors")
            : _vm.currentPage === "tags"
            ? _c("Tags")
            : _vm.currentPage === "profile-fields"
            ? _c("ProfileFields")
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.importContactsModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title:
                  _vm.importContactsType === "multiple"
                    ? "Kişileri İçe Aktar"
                    : "Tekli Kişi Ekle",
                showFooter: false,
                showTitle: false,
                maskClosable: false,
                fullwidth: _vm.importContactsType === "multiple",
                large: _vm.importContactsType === "single",
              },
              on: { cancel: _vm.closeImportContactsModal },
            },
            [
              _vm.importContactsType === "multiple"
                ? _c("ImportContacts", {
                    attrs: { onCancelled: _vm.closeImportContactsModal },
                    on: { importContacts: _vm.handleImportContacts },
                  })
                : _c("SingleContactImport", {
                    attrs: {
                      onCompleted: _vm.onSingleImportCompleted,
                      onCancelled: _vm.closeImportContactsModal,
                    },
                    on: { addContact: _vm.handleAddContact },
                  }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.importStatus
        ? _c("ImportStatusViewer", {
            attrs: { state: _vm.importStatus },
            on: {
              close: function ($event) {
                _vm.importStatus = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedChannelContactType
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.getChannelContactModalTitle(),
                showFooter: false,
                maskClosable: true,
                xlarge: "",
                className: "channel-contacts-modal",
              },
              on: { cancel: _vm.closeChannelContactsModal },
            },
            [
              _vm.selectedChannelContactType === "whatsapp"
                ? _c("WhatsappContactListSwitcher")
                : _vm.selectedChannelContactType === "instagram"
                ? _c("InstagramContactListSwitcher")
                : _vm.selectedChannelContactType === "messenger"
                ? _c("MessengerContactListSwitcher")
                : _vm.selectedChannelContactType === "linkedin"
                ? _c("LinkedinContactListSwitcher")
                : _vm.selectedChannelContactType === "metaLeads"
                ? _c("MetaLeadsContactListSwitcher")
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showExportSettings
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("Kayıtları İndir - Ayarlar"),
                className: "export-settings-modal keydown-prevent-modal",
                showFooter: false,
                xlarge: "",
              },
              on: { cancel: _vm.closeExportSettings },
            },
            [
              _c("ExportSettings", {
                attrs: {
                  fields: _vm.visitorFields,
                  records: _vm.previewRecords,
                },
                on: {
                  start: _vm.onExportSettingsStart,
                  cancel: _vm.closeExportSettings,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.exportInProgress
        ? _c("div", { staticClass: "export-progress-overlay" }, [
            _c(
              "div",
              { staticClass: "export-progress-card" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v("Excel Dışa Aktarım"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(
                    "Toplam " + _vm._s(_vm.exportProgress.total) + " kayıt"
                  ),
                ]),
                _vm._v(" "),
                _c("a-progress", {
                  attrs: {
                    percent: _vm.exportProgress.percent,
                    status: "active",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "detail" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.exportProgress.fetched) +
                          " / " +
                          _vm._s(_vm.exportProgress.total)
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.exportInProgress
                      ? _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { size: "small" },
                            on: { click: _vm.cancelExport },
                          },
                          [
                            _vm._v(
                              "\n                    İptal\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }